import Vue from 'vue';

const OnAnyClick = new Vue();
export default OnAnyClick;

document.addEventListener('mousedown', mouseDown);  //if any touch issues, use hammerjs

OnAnyClick.getDomPath = function (el) {
  let stack = [];
  while (el.parentNode != null) {
    stack.push(el);
    el = el.parentNode;
  }
  return stack;
};

function mouseDown(evt) {
  let path = OnAnyClick.getDomPath(evt.target);
  OnAnyClick.$emit('anyClick', path);
}

OnAnyClick.closeIfNoMatch = function (self, callback) {
  OnAnyClick.$on('anyClick', function (payload) {
    let match = false;
    for (let nodecount = 0; nodecount < payload.length; nodecount++) {
      if (self.$el === payload[nodecount]) {
        match = true;
        break;
      }
    }
    if (!match) {
      callback(payload);
    }
  });
};
